<template>
  <span class="monitoring-block-hint">
    <svg
      class="monitoring-block-hint__icon"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
      />
    </svg>
    {{ $t('monitoringDashboard.clickHint') }}
  </span>
</template>

<script>
  export default {
    name: 'MonitoringBlockHint',
  };
</script>

<style lang="scss" scoped>
  .monitoring-block-hint {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
    color: #94a3b8;
    font-size: 12px;
    font-weight: 400;

    &__icon {
      width: 15px;
      height: 15px;
      fill: currentColor;
      flex-shrink: 0;
    }
  }
</style>
